export const LEAVE_CONNECTION_MODAL_TYPE = {
  SIMPLE: 'simple',
  CONVERSATION: 'conversation',
};
